import React, {useState} from 'react';
import PropTypes from 'prop-types';
import VisibilitySensor from 'react-visibility-sensor';

export const TableRowWrapper = React.memo(function TableRowWrapper({
	rowData,
	isLastRow,
	level,
	nextLevel,
	index,
	render,
	canExpand,
	initiallyExpanded,
	hasGroupings,
	isHeader,
	disableVirtualization,
	onExpansion,
}) {
	const [expanded, setExpanded] = useState(initiallyExpanded);

	const toggleExpansion = () => {
		setExpanded(!expanded);
		if (onExpansion) {
			onExpansion(rowData, !expanded);
		}
	};

	const nextLevelProps = {
		level: nextLevel,
	};

	const renderRow = visible => {
		const tableColumnsProps = {
			level,
			expanded,
			toggleExpansion,
			canExpand,
			isVisible: visible === true,
			hasGroupings,
			isHeader,
			isLastRow,
			index,
		};

		return <div key={index}>{render({rowData, tableColumnsProps, nextLevelProps, expanded})}</div>;
	};

	return disableVirtualization ? (
		renderRow(true)
	) : (
		<VisibilitySensor partialVisibility>
			{({isVisible}) => {
				return renderRow(isVisible);
			}}
		</VisibilitySensor>
	);
});

TableRowWrapper.propTypes = {
	index: PropTypes.any,
	loadMoreFunc: PropTypes.func,
	rowData: PropTypes.object.isRequired,
	level: PropTypes.oneOf([1, 2, 3]).isRequired,
	nextLevel: PropTypes.oneOf([2, 3, false]).isRequired,
	render: PropTypes.func.isRequired,
	canExpand: PropTypes.bool,
	initiallyExpanded: PropTypes.bool,
	hasGroupings: PropTypes.bool,
	isHeader: PropTypes.bool,
	isLastRow: PropTypes.bool,
	disableVirtualization: PropTypes.bool,
	onExpansion: PropTypes.func,
};
